import { render, staticRenderFns } from "./lesson_home.vue?vue&type=template&id=63ebd5c1&scoped=true"
import script from "./lesson_home.vue?vue&type=script&lang=js"
export * from "./lesson_home.vue?vue&type=script&lang=js"
import style0 from "./lesson_home.vue?vue&type=style&index=0&id=63ebd5c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebd5c1",
  null
  
)

export default component.exports